export const RECEIVE_URL_PARAMETERS = 'RECEIVE_URL_PARAMETERS';

export const saveUrlParameters = () => {
  return (dispatch, getState) => {
    const {
      urlParameters
    } = getState();

    // Only save url parameters if there is nothing currently saved.
    // Prevents overriding if a user jumps between multiple sign up pages.
    if (!urlParameters) {
      dispatch({
        type: RECEIVE_URL_PARAMETERS,
        params: window.location.search
      });
    }
  };
};
